import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThesauriComponent } from '@thesauri/thesauri.component';
import { ThesaurusTermsComponent } from '@thesaurus-terms/thesaurus-terms.component';
import { ConfigComponent } from '@maintain/config.component';
import { StatusComponent } from '@status/status.component';

const routes: Routes = [
  {
    path: 'thesauri',
    component: ThesauriComponent
  },
  {
    path: 'thesaurus/:thesaurusId',
    component: ThesaurusTermsComponent
  },
  {
    path: 'maintain',
    component: ConfigComponent
  },
  {
    path: 'status',
    component: StatusComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 
  
}
